export const NUMBER_OF_PRODUCTS_TO_FETCH = 10
export const CARD_HEIGHT = 200
export const CARD_WIDTH = 160
